import axios from 'axios'

let querystring = require('querystring')
const hostName = process.env.NODE_ENV === 'production' ? 'https://api.marinescu.xyz/' : 'https://localhost:44363/'

window.app = { 
    client: 'home.marinescu.xyz',
    secret: '80AC7391F49089FF5055ADE87D04ADB801059C1F',
    host: hostName
};

let isAlreadyFetchingAccessToken = false
let subscribers = []

function getOauthHeader() {
  
  let token = btoa(window.app.client + ':' + window.app.secret);
  return {
    "Authorization": "Basic " + token,
    'Content-Type': 'application/x-www-form-urlencoded',
    "Accept": "application/json"
  };
}

function addSubscriber(callback) {
  subscribers.push(callback)
}


export default () => {
  let crtAxios = axios.create({
    baseURL: hostName
  });


  crtAxios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {

    
    try {
    const { config, response: { status } } = error
    const originalRequest = config
    
    if (status === 401) {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true
        
        axios.create({
          baseURL: hostName
        }).post('api/token',
          querystring.stringify({
            'grant_type': 'refresh_token',
            'refresh_token': localStorage.getItem('refresh_token')
          }),
          {
            headers: getOauthHeader()
          }).then(function (response) {
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("refresh_token", response.data.refresh_token);
          }).catch(function () {
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            window.console.log('/account/login');
            window.vm.$router.push('/account/login');
          }).finally(function () {
            isAlreadyFetchingAccessToken = false;
            while(subscribers.length > 0) {
              let s = subscribers.pop();
              s();
            }
          });
      }


      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber(() => {
          
          originalRequest.headers.Authorization = 'Bearer ' + localStorage.getItem('access_token') 
          resolve(axios(originalRequest))
        })
      })
      return retryOriginalRequest
    }
  } catch {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      window.console.log('/account/login');
      window.vm.$router.push('/account/login');
  }
    return Promise.reject(error)
  })

  return crtAxios;
}